import { fork, all } from 'redux-saga/effects';

import * as catalogs from './catalogs';

export default function* rootSaga() {
  yield all([...Object.values(catalogs)].map(fork));
}
